import { PaginationComponent as BsPaginationComponent } from 'ngx-bootstrap/pagination';

// ngx-bootstrap 22 turned the pagination widget's inputs into signals that are
// mirrored into private fields (_totalItems/_itemsPerPage) by constructor
// effects, and effects only flush AFTER ngOnInit. The widget therefore
// initializes with totalPages computed from a stale totalItems of 0, marks
// itself `inited`, and when the effects finally sync the real totals the
// totalPages setter calls selectPage(this.page) with the page still at its
// default of 1 — pushing 1 through the ControlValueAccessor into
// [(ngModel)]="pagination.currentPage" and wiping the page the still-warm
// PaginationService remembered (e.g. returning from a profile to page 7 kicked
// the user back to page 1). In v18 these were plain @Input setters that ran
// before ngOnInit, so none of this happened.
//
// Until upstream fixes the init ordering (nothing newer than 22.0.0 exists),
// restore the v18 semantics from the outside:
//  1. sync the signal-input mirrors before the original ngOnInit runs, so
//     totalPages is correct from the start and ngModel's restored page is not
//     clamped to 1;
//  2. make the totalPages setter a no-op for unchanged values after init, so
//     the first effect flush no longer re-selects (and thus re-emits) the page.
//
// pagination.component.spec.ts covers the regression; if an ngx-bootstrap
// upgrade changes these internals, that spec is the tripwire.

let isPatched = false;

export function applyNgxBootstrapPaginationInitPatch(): void {
  if (isPatched) {
    return;
  }
  isPatched = true;

  const proto = BsPaginationComponent.prototype as any;

  const originalNgOnInit = proto.ngOnInit;
  proto.ngOnInit = function (this: any): void {
    const totalItems = this.totalItemsInput?.();
    if (totalItems !== undefined) {
      this._totalItems = totalItems;
    }

    const itemsPerPage = this.itemsPerPageInput?.();
    if (itemsPerPage !== undefined) {
      this._itemsPerPage = itemsPerPage;
    }

    originalNgOnInit.call(this);
  };

  const descriptor = Object.getOwnPropertyDescriptor(proto, 'totalPages');
  if (descriptor?.get && descriptor?.set) {
    Object.defineProperty(proto, 'totalPages', {
      ...descriptor,
      set(this: any, value: number) {
        if (this.inited && value === this._totalPages) {
          return;
        }

        descriptor.set.call(this, value);
      }
    });
  }
}

applyNgxBootstrapPaginationInitPatch();
